module.exports = __webpack_public_path__ + "c6f45ccd336b9a74cf0eb15315c58817.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/phone-numbers/confirm-turn-off-recovery/confirm-turn-off-recovery.html
// module id = 2404
// module chunks = 0